export default __webpack_public_path__ + "static/media/19.c4c1b90b.jpg";